/*
 * scroll-fade.js
 * Site-wide reveal-on-scroll for any element with .scroll-fade-target.
 * Critical CSS + the .sf-enabled capability flag are inlined in layout/theme.liquid
 * (head) so the hidden state only applies when JS is enabled (no FOUC, graceful
 * degradation if this file fails to load). This file only attaches the observer.
 */
(function () {
  if (typeof window === 'undefined') return;

  function init() {
    var targets = document.querySelectorAll('.scroll-fade-target');
    if (!targets.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) { targets[i].classList.add('is-visible'); }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();